import React, { useEffect, useRef, useState } from "react";
import Swiper from "swiper";
import striptags from "striptags";
import "../../../node_modules/swiper/swiper.min.css";
import Image from "next/image";
import { parseHtml } from "../../../utils/common";

const OutOffer = ({ industryData }) => {
  const swiperRef = useRef(null);

  useEffect(() => {
    let testimonialsSwiper;

    const initSwiper = () => {
      testimonialsSwiper = new Swiper(".swiper-offering", {
        loop: true,
        spaceBetween: 30,
        slidesPerView: 1.2,
        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
        },
        speed: 2000,
        grabCursor: true,
        navigation: {
          nextEl: ".swiper-next", // Use Swiper's built-in navigation controls
          prevEl: ".swiper-prev", // Use Swiper's built-in navigation controls
        },
        breakpoints: {
          1920: {
            slidesPerView: 3,
          },
          991: {
            slidesPerView: 3,
          },
          767: {
            slidesPerView: 2,
          },
        },
      });
    };

    initSwiper();
    swiperRef.current = testimonialsSwiper;

    return () => {
      if (testimonialsSwiper) {
        testimonialsSwiper.destroy();
      }
    };
  }, []);

  const handlePrevButtonClick = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  const handleNextButtonClick = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };
  const titleWithoutPTag = industryData?.value?.title;
  return (
    <section className="our-offerings-section">
      <div className="our-offerings-inner">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="section-heading">
                <span>{parseHtml(titleWithoutPTag)}</span>
                <p>{parseHtml(industryData?.value?.description)}</p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-lg-12 col-md-12 col-sm-12">
              <div className="offering-slider">
                <div className="swiper swiper-offering">
                  <div className="swiper-arrow">
                    <div
                      className="swiper-prev"
                      onClick={handlePrevButtonClick}
                    ></div>
                    <div
                      className="swiper-next"
                      onClick={handleNextButtonClick}
                    ></div>
                  </div>
                  <div className="swiper-wrapper">
                    {industryData?.value?.list?.map((val, i) => {
                      return (
                        <div className="swiper-slide" key={`${i}_j`}>
                          <div className="offering-card">
                            <div className="offering-card-icon">
                              <Image
                                height={100}
                                width={100}
                                src={val?.value?.image?.url}
                                alt={val?.value?.image?.alt_text ?? 'Learning Management Systems'}
                                loading="eager"
                              />
                            </div>
                            <div className="offering-card-content">
                              <span className="heading-h4 offering-card-title">
                                {parseHtml(val?.value?.title)}
                              </span>
                              <p>{parseHtml(val?.value?.description)}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OutOffer;
